import { Pipe, PipeTransform } from '@angular/core';
import { therapyItems } from '@alberta/konexi-shared'

@Pipe({
  name: 'therapy',
})
export class TherapyPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const therapy = therapyItems.find(t => t.id === value);
    if (therapy) {
      return therapy.displayName;
    }
  }
}
